
export function doubleRaf(callback) {
  requestAnimationFrame(() => {
    requestAnimationFrame(callback)
  })
}

export function getMillisecond() {
  const isPerformanceSupported = (
    window.performance &&
    window.performance.now
  )

  const timeStampInMs = (
    isPerformanceSupported ?
      window.performance.now() + Math.random() :
      Date.now() + '.' + Math.random()
  )

  return timeStampInMs

}

export function PersianNowDate(currentDate = null, endOfDay = false,onlyDate=false) {
  const date = currentDate ? new Date(currentDate) : new Date()

  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  if (onlyDate) {
    return year + '-' + month + '-' + day
  }
  const hours = endOfDay ? '23' : date.getHours()
  const minutes = endOfDay ? '59' : date.getMinutes()
  const seconds = endOfDay ? '59' : date.getSeconds()

  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
}

export function parsMomentEvent(event,moment) {
  event.startDateTime = moment(event.startDateTime, 'jYYYY/jMM/jDD')
  event.endDateTime = moment(event.endDateTime, 'jYYYY/jMM/jDD')
  return event
}
export function parsMomentWithTimeEvent(event,moment) {
  event.startDateTime = moment(event.startDateTime, 'jYYYY/jMM/jDD H:mm')
  event.endDateTime = moment(event.endDateTime, 'jYYYY/jMM/jDD H:mm')
  return event
}

export function queryString(data) {
  let query = Object.keys(data)
    .map(key => {
        if (Array.isArray(data[key])) {
          return Object.values(data[key]).map(value =>  key+'[]='+value).join('&')
        } else {
          return key + '=' + data[key]
        }
      }
    )
    .join('&')

  return query
}
